'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _translate = require('../../language/translate');

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

var _commonFunctions = require('../../helpers/commonFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkIfErrorExistsInQuoteInformation(props, errorKey) {
  return Array.isArray(props.application.quote.information) && props.application.quote.information.filter(function (obj) {
    return obj.key === errorKey;
  }).length > 0;
}

/**
 * Validates the values in the Get Quote portion of the form (the first page).
 * @param {Object} values - The values in the form to validate.
 * @returns {Object} Object of errors found in the form.
 */

exports.default = function (values, props) {
  return {
    applicant: values.applicant.map(function (applicant, i) {
      return {
        dob: !applicant.dob,
        first_name: !applicant.first_name,
        last_name: !applicant.last_name,
        email: i === 0 && !applicant.email,
        additional_data: {
          relationship_to_primary_applicant: ((0, _commonFunctions.associatedForm)() || i > 0) && !applicant.additional_data.relationship_to_primary_applicant
        }
      };
    }),
    application: {
      effective_date: !values.application.effective_date || checkIfErrorExistsInQuoteInformation(props, 'application.effective_date'),
      expiry_date: !values.application.expiry_date || checkIfErrorExistsInQuoteInformation(props, 'application.expiry_date'),
      associated_policy: (0, _commonFunctions.associatedForm)() && (!values.application.associated_policy || checkIfErrorExistsInQuoteInformation(props, 'application.associated_policy')),
      additional_data: {
        eligibility: !values.application.additional_data.eligibility,
        country_of_origin: !values.application.additional_data.country_of_origin,
        existing_policy: (0, _commonFunctions.renewalForm)() && !values.application.additional_data.existing_policy
        // student_number: !associatedForm() && !values.application.additional_data.student_number,
        // staff_member: !associatedForm() && !values.application.additional_data.staff_member,
      }
    },
    errors: props.application.quote.information && Array.isArray(props.application.quote.information)
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/student/Quote.js
// module id = 1785
// module chunks = 0